import styles from './PhotoSliderBlock.module.scss'

const PLACEHOLDER_ROWS = 2
const PLACEHOLDER_COLS = 4

export default function PhotoSliderBlockSkeleton() {
  return (
    <div className={styles.container} aria-busy="true" aria-live="polite">
      <div className={styles.skeletonTitle} />
      <div className={styles.galleryContainer}>
        {Array.from({ length: PLACEHOLDER_ROWS }).map((_, rowIdx) => (
          <div key={rowIdx} className={styles.gallery}>
            {Array.from({ length: PLACEHOLDER_COLS }).map((__, colIdx) => (
              <div key={colIdx} className={styles.skeletonImage} />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
